export default __webpack_public_path__ + "img/rule42back-ee84e232.png";